/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { NenTokenMock, NenTokenMockInterface } from "../NenTokenMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_firstBaseURI",
        type: "string",
      },
      {
        internalType: "address",
        name: "_validator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "AnswerLockedStatusUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "answer",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "credit",
        type: "string",
      },
    ],
    name: "AnswerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "questionCategory",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "question",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "attributeSkinTone",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeHairFront",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeHairBack",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeEar",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeEyes",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeClothing",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeDna",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeFace",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeNeck",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeMouth",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeSpecial",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct NenToken.Attribute",
        name: "attribute",
        type: "tuple",
      },
    ],
    name: "AttributeSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "baseUri",
        type: "string",
      },
    ],
    name: "BaseUriUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintedCount",
        type: "uint256",
      },
    ],
    name: "Minted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "minter",
        type: "address",
      },
    ],
    name: "MinterUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "questionCategory",
                type: "bytes32",
              },
              {
                internalType: "string",
                name: "question",
                type: "string",
              },
              {
                internalType: "bytes32",
                name: "attributeSkinTone",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeHairFront",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeHairBack",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeEar",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeEyes",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeClothing",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeDna",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeFace",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeNeck",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeMouth",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeSpecial",
                type: "bytes32",
              },
            ],
            internalType: "struct NenToken.Attribute",
            name: "attribute",
            type: "tuple",
          },
        ],
        internalType: "struct NenToken.Request",
        name: "request",
        type: "tuple",
      },
    ],
    name: "_prepareMessage",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "answerMaxLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "creditMaxLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "isAnswerLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "metadatas",
    outputs: [
      {
        internalType: "string",
        name: "answer",
        type: "string",
      },
      {
        internalType: "string",
        name: "credit",
        type: "string",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "questionCategory",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "question",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "attributeSkinTone",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeHairFront",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeHairBack",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeEar",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeEyes",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeClothing",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeDna",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeFace",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeNeck",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeMouth",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "attributeSpecial",
            type: "bytes32",
          },
        ],
        internalType: "struct NenToken.Attribute",
        name: "attribute",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ownerAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "mintedCount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "minter",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_answerMaxLength",
        type: "uint256",
      },
    ],
    name: "setAnswerMaxLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_creditMaxlength",
        type: "uint256",
      },
    ],
    name: "setCreditMaxLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_minter",
        type: "address",
      },
    ],
    name: "setMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_validator",
        type: "address",
      },
    ],
    name: "setValidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenIdCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "answer",
        type: "string",
      },
      {
        internalType: "string",
        name: "credit",
        type: "string",
      },
    ],
    name: "updateAnswer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "answer",
        type: "string",
      },
      {
        internalType: "string",
        name: "credit",
        type: "string",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "questionCategory",
                type: "bytes32",
              },
              {
                internalType: "string",
                name: "question",
                type: "string",
              },
              {
                internalType: "bytes32",
                name: "attributeSkinTone",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeHairFront",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeHairBack",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeEar",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeEyes",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeClothing",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeDna",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeFace",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeNeck",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeMouth",
                type: "bytes32",
              },
              {
                internalType: "bytes32",
                name: "attributeSpecial",
                type: "bytes32",
              },
            ],
            internalType: "struct NenToken.Attribute",
            name: "attribute",
            type: "tuple",
          },
        ],
        internalType: "struct NenToken.Request",
        name: "request",
        type: "tuple",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "updateAnswerWithAttribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_baseUri",
        type: "string",
      },
    ],
    name: "updateBaseUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "validator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type NenTokenMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NenTokenMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NenTokenMock__factory extends ContractFactory {
  constructor(...args: NenTokenMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NenTokenMock";
  }

  deploy(
    _firstBaseURI: string,
    _validator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NenTokenMock> {
    return super.deploy(
      _firstBaseURI,
      _validator,
      overrides || {}
    ) as Promise<NenTokenMock>;
  }
  getDeployTransaction(
    _firstBaseURI: string,
    _validator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _firstBaseURI,
      _validator,
      overrides || {}
    );
  }
  attach(address: string): NenTokenMock {
    return super.attach(address) as NenTokenMock;
  }
  connect(signer: Signer): NenTokenMock__factory {
    return super.connect(signer) as NenTokenMock__factory;
  }
  static readonly contractName: "NenTokenMock";
  public readonly contractName: "NenTokenMock";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NenTokenMockInterface {
    return new utils.Interface(_abi) as NenTokenMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NenTokenMock {
    return new Contract(address, _abi, signerOrProvider) as NenTokenMock;
  }
}
